import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { getRegion, readConsent, registerCookieSettingsOpener, saveConsent } from "@/lib/metaPixel";

/** Shown only to visitors in consent regions (EEA/UK/CH or unknown). */
const CookieConsentBanner = () => {
  const [open, setOpen] = useState(false);
  const [region, setRegion] = useState("XX");

  useEffect(() => {
    let alive = true;
    getRegion().then((r) => {
      if (!alive) return;
      setRegion(r.country);
      if (r.requiresConsent && !readConsent()) setOpen(true);
    });
    const off = registerCookieSettingsOpener(() => setOpen(true));
    return () => { alive = false; off(); };
  }, []);

  if (!open) return null;
  const choose = (c: "granted" | "denied") => { saveConsent(c, region); setOpen(false); };

  return (
    <div role="dialog" aria-label="Cookie settings" className="fixed inset-x-0 bottom-0 z-[100] p-3 sm:p-4" style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}>
      <div className="mx-auto max-w-2xl rounded-xl border border-border bg-card p-4 text-card-foreground shadow-lg">
        <p className="text-sm">
          We'd like to use Meta (Facebook) advertising cookies to measure visits, sign-ups and entries from our ads.
          Nothing is set unless you accept. You can change this anytime via "Cookie settings" in the footer.{" "}
          <Link to="/privacy-policy" className="underline text-primary">Privacy policy</Link>
        </p>
        <div className="mt-3 flex gap-2">
          <Button variant="outline" className="flex-1 min-h-11" onClick={() => choose("denied")}>Reject</Button>
          <Button variant="outline" className="flex-1 min-h-11" onClick={() => choose("granted")}>Accept</Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
